// extracted by mini-css-extract-plugin
module.exports = {"search-input-wrapper":"SearchInput_search-input-wrapper__2o-Bf","search-input":"SearchInput_search-input__1LEUZ","remove-button":"SearchInput_remove-button__1y-we"};